import {formDataRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceGetGrades(params) {
    return await postRequest('grades', params);
}
export async function serviceCreateGrade(params) {
    return await postRequest('grades/create', params);
}
export async function serviceUpdateGrade(params) {
    return await postRequest('grades/update', params);
}
export async function serviceGetGradeDetails(params) {
    return await postRequest('grades/detail', params);
}

export async function serviceGradeCheck (params) {
    return await postRequest('grades/check', params);
}
export async function serviceGetGradeReport(params) { 
    return await postRequest('grades/export', params);
}
